import {
	ChangeDetectorRef,
	Component,
	Input,
	OnInit,
	AfterViewInit
} from '@angular/core';
import {
	MatTreeFlatDataSource,
	MatTreeFlattener
} from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { TreeNodeService } from '../../services/tree-node.service';

@Component({
	selector: 'app-tree',
	templateUrl: './tree.component.html',
	styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnInit, AfterViewInit {
	data: any;
	@Input() title = '';

	treeControl = new FlatTreeControl<FlatNode>(
		node => node.level,
		node => node.expandable
	);

	treeFlattener = new MatTreeFlattener<TreeNode, FlatNode>(
		this._transformer,
		node => node.level,
		node => node.expandable,
		node => node.children
	);

	dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

	constructor(
		private cdref: ChangeDetectorRef,
		private treeNodeService: TreeNodeService
	) {}

	ngOnInit(): void {
		this.treeNodeService.nodes.subscribe(nodes => {
			this.dataSource.data = nodes;
		});
	}

	private _transformer(node: TreeNode, level: number) {
		return {
			expandable: (!!node.children && node.children.length > 0) || false,
			name: node.name,
			level
		};
	}

	hasChild = (_: number, node: FlatNode) => node.expandable;

	ngAfterViewInit(): void {
		this.dataSource.data = this.data?.nodes || [];
		this.cdref.detectChanges();
	}
}

export interface TreeNode {
	name?: string;
	children?: TreeNode[];
}

interface FlatNode {
	expandable: boolean;
	name?: string;
	level: number;
}
